import apiCreator from './util/ApiCreator';
const api = apiCreator('/api/dealer-portal/dealer/settings');

export default {
    get (handles) {
        return api.get("/", { params : { handles : handles.join(',') } });
    },
    saveSettings (settings) {
        return api.post("/", settings);
    },
    getPaymentMethods () {
        return api.get("/payment-method");
    },
    savePaymentMethod (method) {
        return api.post("/payment-method", method);
    },
    savePaymentMethodRanks (methods) {
        return api.post("/payment-method-ranks", methods);
    },
    deletePaymentMethod (id) {
        return api.delete(`/payment-method/${id}`);
    },
    togglePaymentMethodActive (id) {
        return api.put(`/payment-method/${id}/toggle-active`);
    },
};
